import { render, staticRenderFns } from "./EditStudent.vue?vue&type=template&id=1b977d9e&scoped=true"
import script from "./EditStudent.vue?vue&type=script&lang=js"
export * from "./EditStudent.vue?vue&type=script&lang=js"
import style0 from "./EditStudent.vue?vue&type=style&index=0&id=1b977d9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b977d9e",
  null
  
)

export default component.exports